export enum TeleexpertiseProvider {
  OMNIDOC = 'OMNIDOC',
  ROFIM = 'ROFIM',
}
